import { Component } from '@angular/core';
import { AuthService } from 'src/app/modules/services/auth/auth.service';
import { UserService } from 'src/app/modules/services/user/user.service';

@Component({
  selector: 'app-home-dashboard',
  templateUrl: './home-dashboard.component.html',
  styleUrls: ['./home-dashboard.component.scss']
})
export class HomeDashboardComponent {
    userName: string = '';

  constructor(
        private authService: AuthService,
        private userService: UserService,

  ) {
    
    const userId = this.authService.getUserIdFromToken();

    if (userId) {
      this.userService.getMenuUsuario(userId).subscribe((user: any) => {    
        this.userName = user.nome;
      });

     
    }

   
  }

}
